/**
 * Venue facts shown on more than one site. GOOGLE_RATING_LINE must stay byte-identical to the
 * literal in client-lamirage-in/src/pages/BookingPage.tsx (pinned there by maisonPages.test.ts);
 * a test asserts BookingPage still contains it, so the copies cannot drift.
 */
export const GOOGLE_RATING_LINE = "★ 4.5 · 1,220 Google reviews";
export const EVENTS_LINE = "1000+ events since 2022";
